import { useTranslation } from "react-i18next";
import { UAParser } from 'ua-parser-js';
import { DIAGNOSTIC_STEP_BROWSER_SUPPORT_KEY, DIAGNOSTIC_STEP_CONNECTIVITY_VALUE } from "@/constants/diagnostics";
import { useIsSM } from "@/hooks/useIsSM";
import { setDiagnosticsStep } from "@/store/features/diagnostics/slice";
import { useAppDispatch } from "@/store/hooks";
import { Button } from "@/ui";
import DiagnosticsSection from "../DiagnosticsSection";

const userAgentParser = new UAParser();
const userAgentInfo = userAgentParser.getResult();

const BrowserSupport = () => {
  const {t} = useTranslation();

  const isSM = useIsSM();

  const dispatch = useAppDispatch();

  const onClickOk = () => {
    dispatch(setDiagnosticsStep(DIAGNOSTIC_STEP_CONNECTIVITY_VALUE));
  };

  const preview = (
    <div className="section-frame padding-sm-large">
    <p>
      <b>{t('browser')}: </b>
      {userAgentInfo.browser.name}
      {' '}
      {userAgentInfo.browser.version}
    </p>
    <p>
      <b>{t('operating_system')}: </b>
      {userAgentInfo.os.name}
      {' '}
      {userAgentInfo.os.version}
    </p>
  </div>
  );

  return (
    <DiagnosticsSection id={DIAGNOSTIC_STEP_BROWSER_SUPPORT_KEY}>
      <div className="section-wrapper">
        <div className="section-content">
          <h2>{t('browser_supported')}</h2>
          <p>{t('browser_supported_description')}</p>
          {isSM && preview}
          <Button onClick={onClickOk}>{t('ok')}</Button>
        </div>
        {!isSM && preview}
      </div>
    </DiagnosticsSection>
  );
};

export default BrowserSupport;